import React from 'react';
import Icon from './Icon';

// Placeholder padrão pra listas vazias. Substitui os "📦 Nenhum produto"
// espalhados pelo app. Use com ícone lucide-react.
const EmptyState = ({ icon, title, description, action, children, className = '' }) => {
  return (
    <div
      className={`flex flex-col items-center justify-center text-center py-12 px-6 ${className}`}
    >
      {icon && (
        <div className="w-16 h-16 rounded-full bg-app-surface-hover flex items-center justify-center mb-4">
          <Icon as={icon} size="xl" className="text-app-text-secondary" />
        </div>
      )}
      {title && <h3 className="text-lg font-semibold text-app-text mb-1">{title}</h3>}
      {description && (
        <p className="text-sm text-app-text-secondary max-w-sm mb-4">{description}</p>
      )}
      {action && <div>{action}</div>}
      {children}
    </div>
  );
};

export default EmptyState;
